// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// NOTE: App.js already provides the Redux store, React Query client (with the
// 401 retry rule), the AntD ConfigProvider/App context, react-toastify's
// ToastContainer, BrowserRouter, AuthContextProvider, TermsGate and
// CookieBanner. This file used to rebuild a second, thinner version of that
// tree by hand, which meant none of the above (toasts, cookie banner, terms
// gate, themed AntD) actually rendered in the live app. Render <App/> so
// there is exactly one app tree.

// Debug output stays in development. (console.error and console.warn are kept so real problems still show.)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
